import { render } from "./OwnerApp.vue?vue&type=template&id=f98afefa&scoped=true"
import script from "./OwnerApp.vue?vue&type=script&lang=js"
export * from "./OwnerApp.vue?vue&type=script&lang=js"

import "./OwnerApp.vue?vue&type=style&index=0&id=f98afefa&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f98afefa"]])

export default __exports__